import { AgencyType } from "@/types";
import axios from "axios"
import { defineStore } from "pinia"
import { computed, ref } from "vue"
import { handleError } from "./storeHelper";

export const useAgencyTypeStore = defineStore('agencyTypesStore', () => {

    const apiUrl = "api/v1/agency-type";

    const loading = ref<boolean>(false);

    const items = ref<AgencyType[]>([]);

    const list = async function () {

        try {
            loading.value = true;
            const response = await axios.get<AgencyType[]>(apiUrl);
            items.value = response.data;
        }
        catch (error) {
            handleError(error);
            throw error;
        }
        finally {
            loading.value = false;
        }        
    }

    return { loading, items, list }
})